import { Service } from '@roc/feature-app-core';

const url = {
  GET_LENDER_LICENSES_GRID: '/api/v1/lender/license/getDashboardGrid',
  DOWNLOAD_LENDER_DOCUMENT: '/api/v1/loan/lenderdocuments/downloadDocument',
};

export class LenderLicensesService extends Service {
  getLenderLicensesGrid(urlParams: string) {
    return this.get(`${url.GET_LENDER_LICENSES_GRID}?${urlParams}`);
  }

  downloadLenderDocument(documentId: number) {
    return this.get(
      `${url.DOWNLOAD_LENDER_DOCUMENT}?documentId=${documentId}`,
      {},
      { responseType: 'arraybuffer' }
    );
  }
}
